import React, { MouseEventHandler } from 'react';
import { Button } from '~/UIKit';
import cx from 'classnames';
import { PRIMARY_BLUE, WHITE, DARK_WHITE } from '~/Constants/Colors.constants';
import { makeStyles } from '~/UIKit/Style';

const useStyles = (variation: string) =>
  makeStyles(
    () => {
      const isPrimary = variation === 'primary';
      const wrapperSize = isPrimary ? 44 : 26;
      const buttonSize = isPrimary ? 38 : 24;
      const boxShadow = `0px 0px 0px ${isPrimary ? 0 : '1px'} ${DARK_WHITE}`;

      return {
        wrapper: {
          display: 'flex',
          height: wrapperSize,
          width: wrapperSize,
          borderRadius: '100%',
          boxShadow,
        },
        button: {
          borderRadius: '100%',
          width: buttonSize,
          minWidth: 'inherit',
          height: buttonSize,
          margin: 'auto',
          padding: 0,
          transition:
            // eslint-disable-next-line max-len
            'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
        },
        selected: {
          border: `3px solid ${WHITE}`,
          boxSizing: 'content-box',
          boxShadow: `0px 0px 0px 2px ${PRIMARY_BLUE}`,
        },
        selectedColorWrapper: {},
      };
    },
    { name: 'ColorButton' },
  );

interface ColorButtonProps {
  color: string;
  onClick?: MouseEventHandler<HTMLButtonElement> | undefined;
  isButtonSelected?: boolean;
  className?: string;
  dontUseButtonElement?: boolean;
  disabled?: boolean;
  variation?: 'primary' | 'secondary';
}

export const ColorButton = ({
  onClick,
  color,
  isButtonSelected = true,
  className,
  dontUseButtonElement,
  disabled,
  variation = 'primary',
  ...props
}: ColorButtonProps) => {
  const { classes } = useStyles(variation)();
  return (
    <div className={classes.wrapper}>
      {dontUseButtonElement ? (
        <div
          className={cx(classes.button, className, {
            [classes.selected]: isButtonSelected,
          })}
          style={{ backgroundColor: color || WHITE }}
          {...props}
        />
      ) : (
        <Button
          className={cx(classes.button, className, {
            [classes.selected]: isButtonSelected,
          })}
          style={{ backgroundColor: color || WHITE }}
          onClick={onClick}
          disabled={disabled}
          type="button"
          {...props}
        />
      )}
    </div>
  );
};
